import React, { Component, useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, reduxForm } from 'redux-form'
import { Card, CardHeader, CardBody, Row, Col, Button, Input, Label, Form, FormGroup, Alert, FormFeedback } from 'reactstrap'
import { validationHelper, normalizeHelper } from '../../../../common/helpers'
import { messages } from '../../../../common/constants'
import { toast } from 'react-toastify'
import { getNewsletter, resetNewsletter, updateNewsletter, resetUpdateNewsletter } from '../../../../store/newsletter/actions'
import { MainLoader, ClosableImage } from '../../../../components';
import { FilePond, registerPlugin } from 'react-filepond';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
registerPlugin(FilePondPluginImagePreview, FilePondPluginFileValidateType);

function NewsletterEdit(props) {
  const
    [preview_img, setPreview_img] = useState(null),
    [main_img, setMain_img] = useState(null),
    { handleSubmit, loading, error } = props;

  useEffect(() => {
    props.getNewsletter(props.match.params.id)
    return () => {
      props.resetNewsletter();
      props.resetUpdateNewsletter();
    };
  }, [])

  function onSubmit(values) {
    props.updateNewsletter(props.match.params.id, values, preview_img, main_img, () => {
      toast.success('Noticia actualizada satisfactoriamente')
      props.history.push('/administration/newsletters')
    })
  }

  function renderNewsletterClosableImg(main_img) {
    return <FormGroup row>
      <Col md='2' lg='1'>
        <Label>{main_img ? 'Foto Principal (1280x720):' : 'Foto Previa (600x600):'}</Label>
      </Col>
      <Col xs="12" md="5">
        <ClosableImage
          src={main_img ? props.initialValues.main_img : props.initialValues.preview_img}
          onClose={e => {
            e.preventDefault()
            main_img ? setMain_img({}) : setPreview_img({})
          }}
        />
      </Col>
    </FormGroup >
  }
  function renderInputImg(main_img) {
    return <FormGroup row>
      <Col md='2' lg='1'>
        <Label>{main_img ? 'Foto Principal (1280x720):' : 'Foto Previa (600x600):'}</Label>
      </Col>
      <Col xs="12" md="5">
        <FilePond
          labelIdle='Arrastra y Suelta una foto o <span class="filepond--label-action"> Elige </span>'
          required={true}
          acceptedFileTypes='image/jpeg, image/png'
          labelFileTypeNotAllowed='Archivo no válido'
          onupdatefiles={fileItems => {
            if (fileItems.length == 0) return;
            main_img ? setMain_img(fileItems[0].file) : setPreview_img(fileItems[0].file)
          }}
          onremovefile={(file) => {
            main_img ? setMain_img(null) : setPreview_img(null)
          }}
        />
      </Col>
    </FormGroup>
  }


  function renderInputField(field) {
    const { meta: { touched, error } } = field
    const hasError = touched && error ? true : false
    const labelClass = field.labelClass ? field.labelClass : 'mt-1'

    return <FormGroup row>
      <Col md='2' lg='1'>
        <Label className={labelClass} >{field.label}</Label>
      </Col>
      <Col xs="12" md="5">
        <Input {...field.input} invalid={hasError} type={field.type} />
        {hasError == true
          ? <FormFeedback>{error}</FormFeedback>
          : null
        }
      </Col>
    </FormGroup>
  }

  return loading
    ? <MainLoader />
    : error
      ? <Alert color="danger">
        {error}
      </Alert>
      : <div className='animated'>
        <Card>
          <CardHeader>
            Editar Noticia
          </CardHeader>
          <CardBody>
            {props.updatedError
              ? <Alert color="danger">
                {props.updatedError}
              </Alert>
              : <Form onSubmit={handleSubmit(handleSubmit(onSubmit))} >
                <Field name='title' label='Titulo *:' type='text' component={renderInputField} />
                <Field name='hashTags' label='Hash Tags *:' type='text' component={renderInputField} />
                <Field name='short_desc' label='Descripción corta *:' type='text' component={renderInputField} />
                <Field name='large_desc' label='Texto de la noticia *:' type='textarea' component={renderInputField} />
                {props.initialValues && props.initialValues.preview_img && !preview_img
                  ? renderNewsletterClosableImg(false)
                  : renderInputImg(false)
                }
                {props.initialValues && props.initialValues.main_img && !main_img
                  ? renderNewsletterClosableImg(true)
                  : renderInputImg(true)
                }
                <Row>
                  <Col className='mt-3'>
                    <Button type='submit' disabled={props.updatedLoading} color='primary' className='mr-2' ><i className="fa fa-save mr-1" /> Guardar</Button>
                    <Button color='secondary' onClick={() => props.history.push('/administration/newsletters')} ><i className="fa fa-chevron-left mr-1" /> Cancelar</Button>
                  </Col>
                </Row>
              </Form>
            }
          </CardBody>
        </Card>
      </div>
}

function validate(values) {
  const errors = {}

  if (validationHelper.stringIsNullOrEmpty(values.title)) {
    errors.title = messages.MANDATORY_FIELD
  }
  if (validationHelper.stringIsNullOrEmpty(values.hashTags)) {
    errors.hashTags = messages.MANDATORY_FIELD
  }
  if (validationHelper.stringIsNullOrEmpty(values.short_desc)) {
    errors.short_desc = messages.MANDATORY_FIELD
  }
  if (validationHelper.stringIsNullOrEmpty(values.large_desc)) {
    errors.large_desc = messages.MANDATORY_FIELD
  }

  return errors
}

function mapStateToProps(state) {
  const
    { newsletter, loading, error } = state.newsletter.activeNewsletter,
    { updateNewsletter } = state.newsletter;

  return {
    initialValues: newsletter,
    loading,
    error,

    updatedNewsletter: updateNewsletter.newsletter,
    updatedError: updateNewsletter.error,
    updatedLoading: updateNewsletter.loading,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getNewsletter,
    updateNewsletter,
    resetNewsletter,
    resetUpdateNewsletter
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'NewsletterEditForm',
  touchOnBlur: false,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
  validate
})(NewsletterEdit))


// WEBPACK FOOTER //
// ./src/scenes/Administration/Newsletter/NewsletterEdit/NewsletterEdit.js